<template>
	<v-btn 
		:href="href"
		target="_blank"
		:title="title"
		v-bind="$attrs"
	>
		<slot>{{ config.line }}</slot>
	</v-btn>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	data:() => ({
		href: null,
		title: null
	}),
	computed: {
		...mapGetters(['config'])
	},
	mounted() {
		this.href=`https://line.me/ti/p/~${this.config.line}`
		this.title = this.$attrs.title || `ไลท์แชทกับ ${this.config.company}`
	}
}

</script>
